import React from 'react';
import { useSidebar } from '@rocketseat/gatsby-theme-docs-core';
import Assessments from './Assessments';
import Button from './Button';
import {
  Billboard,
  GettingAround,
  GettingAroundContent,
  GettingAroundHeader,
  Environment,
  EnvironmentContent,
  EnvironmentHeader,
  EnvironmentFooter,
  Portal
} from './styles';

export default function Landing() {
  const data = useSidebar();
  const [firstPageData] = data;

  return (
    <>
      <Billboard>
        <h1>A66 Northern Trans-Pennine Route Upgrade</h1>
        <h4>Digital Preliminary Environmental Information (PEI) Report</h4>
        <p>The PEI report enables consultees to understand the likely environmental effects of the proposed scheme.​ We’re always looking for innovative ways in which to make it easier to access information about the scheme, that’s why we’re pleased to introduce our Digital PEI report.</p>
        <Button label={firstPageData.node.label} link={firstPageData.node.link} />
      </Billboard>
      <GettingAround>
        <GettingAroundHeader />
        <GettingAroundContent>
          <h2>Getting around</h2>
          <p>The Digital PEI report combines reports, figures and appendices so you can examine the environmental context of the scheme in an interactive and intuitive way.</p>
          <p>Each section of the PEI Report can be accessed via the links along the left hand side, which take you to the relevant page. A summary of the findings is provided along with links to the specific chapters, figures and appendices for further information. If you wish to download the information, the download section also provides links to each section of the report.</p>
        </GettingAroundContent>
      </GettingAround>
      <Environment>
        <EnvironmentHeader />
        <EnvironmentContent>
          <div>
            <h2>Environmental factors</h2>
            <p>Explore the full set of environmental factors in more detail by clicking on the factor you are interested in. This will provide links to supporting chapters, appendices and figures.​</p>
          </div>
          <div>
            <Assessments />
          </div>
        </EnvironmentContent>
        <EnvironmentFooter />
      </Environment>
      <Portal>
        <p>This portal will remain active throughout the consultation process.</p>
        <a href="https://highwaysengland.co.uk/" target="_blank" rel="noopener noreferrer">www.highwaysengland.co.uk</a>
      </Portal>
    </>
  );
}